var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("h4", [_vm._v("Generate New Link")]),
    _vm._v(" "),
    _c("div", { staticClass: "well" }, [
      _vm.errors && _vm.errors.length
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c(
              "ul",
              _vm._l(_vm.errors, function(error) {
                return _c("li", { key: error }, [
                  _vm._v("\n          " + _vm._s(error) + "\n        ")
                ])
              }),
              0
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-6" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "new-link-activation" } }, [
              _vm._v("Link activation date *")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newLink.activationDateString,
                  expression: "newLink.activationDateString"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "new-link-activation",
                type: "datetime-local",
                max: _vm.newLink.expirationDateString,
                disabled: true
              },
              domProps: { value: _vm.newLink.activationDateString },
              on: {
                change: _vm.setDefaultExpiration,
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.newLink,
                    "activationDateString",
                    $event.target.value
                  )
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "new-link-expiration" } }, [
              _vm._v("Link expiration date *")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newLink.expirationDateString,
                  expression: "newLink.expirationDateString"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "new-link-expiration",
                type: "datetime-local",
                min: _vm.newLink.activationDateString,
                disabled: true
              },
              domProps: { value: _vm.newLink.expirationDateString },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.newLink,
                    "expirationDateString",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-6" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "new-link-total-capacity" } }, [
              _vm._v("Total Capacity")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newLink.totalCapacity,
                  expression: "newLink.totalCapacity"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "new-link-total-capacity",
                type: "number",
                disabled: true
              },
              domProps: { value: _vm.newLink.totalCapacity },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.newLink, "totalCapacity", $event.target.value)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "new-link-license-end" } }, [
              _vm._v("License end date")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.newLink.licenseEndDateString,
                  expression: "newLink.licenseEndDateString"
                }
              ],
              staticClass: "form-control",
              attrs: {
                id: "new-link-license-end",
                type: "date",
                disabled: true
              },
              domProps: { value: _vm.newLink.licenseEndDateString },
              on: {
                input: function($event) {
                  if ($event.target.composing) return
                  _vm.$set(
                    _vm.newLink,
                    "licenseEndDateString",
                    $event.target.value
                  )
                }
              }
            })
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", [_c("i", [_vm._v(_vm._s(_vm.timezoneMessage))])]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("label", { attrs: { for: "new-link-notes" } }, [_vm._v("Notes")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.newLink.notes,
              expression: "newLink.notes"
            }
          ],
          staticClass: "form-control",
          attrs: {
            rows: "4",
            placeholder: "e.g. school names, bitly URL, etc.",
            id: "new-link-notes"
          },
          domProps: { value: _vm.newLink.notes },
          on: {
            input: function($event) {
              if ($event.target.composing) return
              _vm.$set(_vm.newLink, "notes", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm.usesExternalId
        ? _c("p", { staticClass: "alert alert-warning" }, [
            _vm._v(
              "\n      When using accounts created by Signup Links, the user will NOT be able to use Single Sign-On\n      (SSO) until their district adds them to the list of approved users. Until then, they must\n      sign in with email and password.\n    "
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          attrs: { disabled: _vm.loading },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.generateLink.apply(null, arguments)
            }
          }
        },
        [
          _vm._v("\n      Generate new link\n      "),
          _vm.loading
            ? _c("i", { staticClass: "fa fa-spinner fa-spin" })
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }